<template>
  <div v-if="data.purchaseId" class="history contents">
    <div class="view">
      <dl class="purchaseDate">
        <dt class="accessibilityHide">
          {{ $t('common.accessibility.purchase_date') }}
        </dt>
        <dd>{{ date }}</dd>
      </dl>
      <dl class="purchaseNum">
        <dt>{{ $t('purchase.order_number') }}</dt>
        <dd>{{ data.purchaseId }}</dd>
      </dl>
      <ul class="listTypeCart">
        <li
          class="productItem"
          v-for="(product, index) in data.purchaseProductList"
          :key="index"
        >
          <list-item
            :product="product"
            :productsCount="data.purchaseProductList.length"
            @refreshDetail="refreshDetail"
          />
        </li>
      </ul>
    </div>

    <div v-if="isShippingProduct" class="deliveryInfo">
      <h2 class="subTitle">{{ $t('purchase.shipping_info') }}</h2>

      <div class="postInfo">
        <ul>
          <li class="personalInfo">
            <div>
              <strong class="name">
                {{ deliveryInformation.receiverName || '' }}
              </strong>
              <span class="phone">
                {{ deliveryInformation.phoneNumber || '' }}
              </span>
            </div>
          </li>
          <li>
            <span>
              {{
                deliveryInformation.zipCode
                  ? `[${deliveryInformation.zipCode}]`
                  : ''
              }}
            </span>
            {{ deliveryInformation.address || '' }}
          </li>
          <li>
            {{ deliveryInformation.detailAddress || '' }}
          </li>
        </ul>

        <div class="postExtraInfo">
          <p>
            {{
              deliveryInformation.requestInfo
                ? `${$t('purchase.delivery_request_info')} :`
                : ''
            }}
          </p>
          <p class="postMessage">{{ deliveryInformation.requestInfo || '' }}</p>
        </div>
      </div>
    </div>

    <div class="payInfo">
      <h2 class="subTitle">{{ $t('purchase.payment_info') }}</h2>
      <div v-if="this.data.purchaseProductList">
        <dl>
          <dt>{{ $t('purchase.total_product_amount') }}</dt>
          <dd>
            {{
              $t('common.unit_and_value', {
                value: productPriceObj.displayPrice.addComma(),
                unit: currencyUnit
              })
            }}
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('purchase.discount_amount') }}</dt>
          <dd>
            -
            {{
              $t('common.unit_and_value', {
                value: productPriceObj.benefit.addComma(),
                unit: currencyUnit
              })
            }}
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('purchase.total_payment_amount') }}</dt>
          <dd>
            {{
              $t('common.unit_and_value', {
                value: productPriceObj.price.addComma(),
                unit: currencyUnit
              })
            }}
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('purchase.payment_method') }}</dt>
          <dd>{{ data.paymentTypeName }}</dd>
        </dl>
        <button
          type="button"
          @click="handleClick"
          class="btReceipt"
          v-if="data.paymentType === 2"
        >
          {{ $t('purchase.cash_receipt_info') }}
          <span class="icon iconMore4"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MyAPI from '@/api/my'
import ListItem from '@/views/my/ListItem'
import { mapActions } from 'vuex'
import { calProductsPriceObejct } from '@/utils'

export default {
  components: {
    ListItem
  },
  props: {
    purchaseId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      data: {},
      paymentType: {
        1: this.$t('status.payment.kakaopay'),
        2: this.$t('status.payment.tosspay'),
        3: this.$t('status.payment.payco'),
        4: this.$t('status.payment.cultural_voucher'),
        5: this.$t('status.payment.credit_card')
      },
      deliveryInformation: {
        receiverName: '',
        phoneNumber: '',
        zipCode: '',
        address: '',
        detailAddress: '',
        requestInfo: ''
      }
    }
  },
  computed: {
    productPriceObj() {
      return calProductsPriceObejct(this.data.purchaseProductList)
    },
    isShippingProduct() {
      const shippingProduct = this.data.purchaseProductList.find(product => {
        return product.type === 3 || product.type === 4
      })

      return shippingProduct !== undefined
    },
    date() {
      return this.data.purchaseDate.substring(0, 10)
    },
    currencyUnit() {
      return this.data.purchaseProductList[0].currencyUnit
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    handleClick() {
      MyAPI.getReceipt(this.purchaseId, ({ data }) => {
        const { paymentReceipt } = data
        this.openModal({
          type: 'alert',
          header: this.$t('purchase.cash_receipt_info'),
          message: `<table>
                      <tbody>
                          <tr>
                            <th>${this.$t('purhcase.issue_date')}</th>
                            <td>${paymentReceipt.issueDate}</td>
                          </tr>
                          <tr>
                            <th>${this.$t('purhcase.amount')}</th>
                            <td>${paymentReceipt.issueAmount.addComma()}${this.$t(
            'common.unit_with_value.unit_currency'
          )}</td>
                          </tr>
                          <tr>
                            <th>${this.$t('purhcase.payment_method')}</th>
                            <td>${paymentReceipt.categoryName}</td>
                          </tr>
                          <tr>
                            <th>${this.$t(
                              'purhcase.issue_approval_number'
                            )}</th>
                            <td>${paymentReceipt.issueNumber}</td>
                          </tr>
                      </tbody>
                    </table>
                    <p>※ ${this.$t('purhcase.cash_receipt_note')}</p>`
        })
      })
    },
    refreshDetail() {
      MyAPI.getPurchaseDetail(this.purchaseId, responseData => {
        this.data = responseData.data

        if (this.isShippingProduct) {
          this.deliveryInformation = responseData.data.delivery
        }
      })
    }
  },
  mounted() {
    MyAPI.getPurchaseDetail(this.purchaseId, responseData => {
      this.data = responseData.data

      if (this.isShippingProduct) {
        this.deliveryInformation = responseData.data.delivery
      }
    })
  }
}
</script>

<style lang="scss">
.history {
  .subTitle {
    height: 42px;
    padding: 15px 16px 0;
    margin: 0;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 1px solid #d6d6db;
    box-sizing: border-box;
  }

  .payInfo {
    margin-top: 10px;
    background-color: #fff;
    border-bottom: 1px solid #efefef;

    div {
      padding: 14px 16px;
      text-align: right;
    }
    dl {
      display: table;
      width: 100%;
      height: 26px;
      text-align: left;
    }
    dt,
    dd {
      display: table-cell;
    }
    dt {
      font-size: 13px;
      color: #636376;
    }
    dd {
      font-size: 15px;
      text-align: right;
    }
  }
}
</style>

<style lang="scss" scoped>
.history {
  .payInfo {
    dl:nth-last-of-type(2),
    dl:nth-last-of-type(1) {
      font-weight: bold;
      dt,
      dd {
        padding-top: 13px;
        height: 26px;
      }
      dt {
        font-size: 14px;
        color: #151721;
        font-weight: normal;
      }
      dd {
        font-size: 16px;
      }
    }
    dl:nth-last-of-type(2) {
      margin-top: 3px;
      border-top: 1px solid #636376;
      dd {
        color: #6134f1;
      }
    }
    dl:nth-last-of-type(1) {
      dt,
      dd {
        padding-top: 10px;
      }
    }
    .btReceipt {
      width: 126px;
      height: 22px;
      padding-top: 1px;
      margin-top: 8px;
      font-size: 12px;
      color: #636376;
      border: 1px solid #d6d6db;
      .icon {
        margin-top: -3px;
      }
    }
  }
}
</style>
